import { mapActions } from 'vuex';

export default {
  name: 'page-cancel-pending-ordered-call',
  props: ['widgetStyle', 'hotlineDetails', 'hotlineDestinationNumber'],
  computed: {
    style() {
      return {
        backgroundColor: this.widgetStyle.main_color,
        borderColor: this.widgetStyle.main_color,
      };
    },
    callStart() {
      const callStartPart = this.hotlineDetails.callStart.split('T');
      const callDate = callStartPart[0];
      const callTime = callStartPart[1].split('.')[0];

      return `${callDate} ${callTime}`;
    },
  },
  methods: {
    ...mapActions(['toggleWidgetModal', 'cancelCallRequest', 'showErrorMessage']),
  },
  sockets: {
    HOTLINE_CALL_REQUEST_CANCELLED() {
      this.showErrorMessage('Połączenie zostało anulowane');
    },
  },
};
